import {http} from "../../Services/Http/HttpClient";

export const refundPaymentOrder = async (id: string): Promise<unknown> => {
    return await http.post(`/payment-orders/${id}/refund`)
}
